import { useEffect, useState } from 'react';

const dashboardNavigationSelector = `.blk-ac-dashboard-navigation`;

/**
 * Returns true if there is a dashboard navigation (you are on the AC dashboard)
 */
export function useIsDashboardNav() {
	const [isDashboardNavigation, setDashboardNavigation] =
		useState<boolean>(false);

	useEffect(() => {
		setDashboardNavigation(
			Boolean(document.querySelectorAll(dashboardNavigationSelector).length)
		);
	}, []);

	return isDashboardNavigation;
}
